var handleDetail = window.location.pathname.split("/");

handleDetail = handleDetail[handleDetail.length - 1];

var getShopId = localStorage.getItem("shopId");

if (handleDetail || localStorage.getItem("detailId")) {
  getSize();
  getModel();
}

function getSize() {
  // var urlSize = 'https://user-api.heychic.net/web/product/sizeData';
  var urlSize = `${heychic_api}/web/product/sizeData`;

  var paramsSize = {
    shop_id: getShopId || "59363262637",
  };

  // 根据条件添加 product_handle 或 product_number
  if (!$("body").hasClass("edit-cart-show")) {
    paramsSize.product_handle = handleDetail;
  } else {
    paramsSize.product_number = localStorage.getItem("detailId");
  }

  getProductPreOrder(localStorage.getItem("detailId"))

  // 使用 URLSearchParams 对象来处理参数
  var urlParams = new URLSearchParams(paramsSize);

  // 添加查询参数到 URL 中
  urlSize = `${urlSize}?${urlParams.toString()}`;

  fetch(urlSize)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      // data.data.size_data不为空数组时
      if (data.code == 200) {
        if (data.data.size_data instanceof Array == false) {
          var sizeDataList = data.data.size_data.size_data;
          // if(sizeDataList.length > 0){
          //   $(".productView-options #measure-size").css("display", "block");
          // }
          
          // 获取size_tag
          var getSizeTag = data.data.size_data.size_tag || [];
          var getOtherData = data.data.other_data.size_tag_to_field;
          var newTag = getOtherData[getSizeTag] || [];
          var getSizeTable = data.data.size_table || [];
          // var getSizeTable = [];
          var typeInfo = {
            fitType: data.data.product_info.product_attr_fit_type - 1,
            thickness: data.data.product_info.product_attr_thickness - 1,
            stretch: data.data.product_info.product_attr_stretch - 1,
          };
          var measureImg = data.data.product_info.size_measure_image || "";

          // 根据不同的类名做判断显示
          if ($("body").hasClass("edit-cart-show")) {
            localStorage.setItem(
              "sizeDataListDetail",
              JSON.stringify(sizeDataList)
            );
            localStorage.setItem("newTagDetail", JSON.stringify(newTag));
            localSizeListDetail =
              sizeDataList &&
              sizeDataList.length &&
              sizeDataList.filter(
                (item) => item.variant_id == localStorage.getItem("itemId")
              );

            // if(localSizeListDetail && localSizeListDetail.length > 0){
            //  $(".halo-edit-cart-popup #measure-size").css("display", "block");
            // }

            console.log("localSizeListDetail-----------------------", localSizeListDetail)
          } else {
            localStorage.setItem("sizeDataList", JSON.stringify(sizeDataList));
            // 过滤出的数组存入本地,显示Length相关参数
            localStorage.setItem("newTag", JSON.stringify(newTag));
          }
          localStorage.setItem("getSizeTable", JSON.stringify(getSizeTable));
          localStorage.setItem("typeInfo", JSON.stringify(typeInfo));
          localStorage.setItem("measureImg", measureImg);
        } else {
          localStorage.setItem("newTag", []);
          localStorage.setItem("newTagDetail", []);
        }
        
      }
    })
    .catch((error) => {
      console.error("Fetch error:", error);
      // 处理错误
    });

    if ($("body").hasClass("edit-cart-show")) {
      saveVariantId(true, localStorage.getItem("itemId"), localStorage.getItem("detailId"))
    }
}

function getModel() {
  // var urlSizeModel = 'https://user-api.heychic.net/web/product/modelDetails';
  var urlSizeModel = `${heychic_api}/web/product/modelDetails`;
  var paramsSizeModel = {
    shop_id: getShopId || "59363262637",
  };

  // 根据条件添加 product_handle 或 product_number
  if (!$("body").hasClass("edit-cart-show")) {
    paramsSizeModel.product_handle = handleDetail;
  } else {
    paramsSizeModel.product_number = localStorage.getItem("detailId");
  }

  // 使用 URLSearchParams 对象来处理参数
  var urlParamsModel = new URLSearchParams(paramsSizeModel);

  // 添加查询参数到 URL 中
  urlSizeModel = `${urlSizeModel}?${urlParamsModel.toString()}`;

  fetch(urlSizeModel)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      if (data.code == 200) {
        if (data.data.length) {
          const $container = $("#model-container");
          // 模特
          $("#model-container").css("display", "block");
          $container.empty();

          const modelInfos = data.data || [];
          localStorage.setItem("modelInfos", JSON.stringify(modelInfos));

          if (modelInfos.length > 0) {
            data.data.forEach((item) => {
              const modelBlock = `
                    <div class="model-text">
                        ${
                          item.model_image
                            ? `<img src="${item.model_image}" alt="model-image" class="model-image"></img>`
                            : ""
                        }
                        <div>
                        <div><span class="model-name">Model Wears Size: </span><span class="model-wears">${
                          item.now_wearing
                        }</span></div><br>
                        <div><span class="model-name">Height: </span><span class="model-height">${
                          item.model_height
                        }</span> cm</div>
                        <div><span class="model-name">Bust: </span><span class="model-bust">${
                          item.model_bust
                        }</span> cm</div>
                        <div><span class="model-name">Waist: </span><span class="model-waist">${
                          item.model_waist
                        }</span> cm</div>
                        <div><span class="model-name">Hips: </span><span class="model-hips">${
                          item.model_hips
                        }</span> cm</div>
                        </div>
                    </div>
                `;

              $container.append(modelBlock);
            });
          }
        } else {
          $("#model-container").css("display", "none");
          $(".modelInfo").css("display", "none");
          $('.modelLine').css('display','none');
        }
      }
    })
    .catch((error) => {
      // 处理错误
      console.error("Fetch error:", error);
    });
}
